module.exports = __webpack_public_path__ + "img/liquidity.5f0f3289.jpg";